module.exports = __webpack_public_path__ + "img/joinUs2.c529cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/joinUs2.png
// module id = KSUT
// module chunks = 0